const loadEticketModule = () => ({
    hasRouter: false,
    modules: [],
});
export default loadEticketModule;
